// Field and hub alerts panel (#31): what's on hold and why, a line of
// real-world context, and the ground-crew button where the crew can help.
// Rows update in place (syncList) so a click never lands on a rebuilt button.

import { ALERT_KINDS } from '../config/constants.js';
import { alertDetail, canDispatch } from '../core/alerts.js';
import { $, setText, setClass, setHidden, syncList } from './dom.js';

const ICONS = {
  person: '🚶', birds: '🐦', tower: '🗼', padBlocked: '⛔', lowPower: '⚡', emergency: '🆘', stranded: '🔋',
};

export function createAlertsPanel(section, listEl, countEl, { onDispatch }) {
  const cache = new Map();

  listEl.addEventListener('click', (e) => {
    const btn = e.target.closest('button[data-alert]');
    if (btn && !btn.disabled) onDispatch(Number(btn.dataset.alert));
  });

  function create(a) {
    const el = document.createElement('div');
    el.dataset.id = a.id;
    el.innerHTML = `
      <div class="al-row1"><span class="al-icon" aria-hidden="true"></span><span class="al-title"></span><span class="al-time"></span></div>
      <div class="al-detail"></div>
      <div class="al-fact"></div>
      <button type="button" class="al-act" hidden></button>`;
    return el;
  }

  function update(el, a, s) {
    const kind = ALERT_KINDS[a.kind];
    const crewOnIt = s.alerts.crew?.alertId === a.id;
    setClass(el, `alert-row ${a.kind}${crewOnIt ? ' crewing' : ''}`);
    setText($('.al-icon', el), ICONS[a.kind]);
    setText($('.al-title', el), kind.title);
    let time = '';
    if (crewOnIt) time = `crew ${Math.ceil(s.alerts.crew.left)}s`;
    else if (a.left !== null) time = `${Math.max(0, Math.ceil(a.left))}s`;
    setText($('.al-time', el), time);
    setText($('.al-detail', el), alertDetail(a));
    setText($('.al-fact', el), kind.fact);
    const btn = $('.al-act', el);
    setHidden(btn, !kind.action || crewOnIt);
    if (kind.action) {
      btn.dataset.alert = a.id;
      setText(btn, kind.action);
      // an emergency's button is the craft's own diversion, not the crew
      const can = a.kind === 'emergency' || canDispatch(s, a.id);
      if (btn.disabled !== !can) btn.disabled = !can;
      btn.title = can ? '' : 'The ground crew is busy';
    }
  }

  return {
    update(s) {
      const list = s.alerts?.enabled ? s.alerts.list : [];
      setHidden(section, list.length === 0);
      setText(countEl, s.alerts?.crew ? 'crew out' : `${list.length} active`);
      syncList(listEl, cache, list, create, (el, a) => update(el, a, s));
    },
  };
}
